export const BANNER_CLOSE_DELAY_MS = 3000;

export const TIMESTAMP_7_DAYS_IN_MC = 604800000;
